import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const ModalAddDeposit = ({ isVisible, onClose, orderId }) => {
  const [advanceDepositValue, setAdvanceDepositValue] = useState("");
  const [advanceDepositType, setAdvanceDepositType] = useState("%"); 

  // Function to handle the product update logic
  const updateProduct = async () => {
    try {
      await axios.put(`https://server-gs.vercel.app/admin/add-deposit/${orderId}`, {
        advanceDepositValue,
        advanceDepositType,
      });

      Swal.fire({
        title: "Success!",
        text: "Added advance deposit successfully.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      onClose(); // Close modal on success
    } catch (error) {
      console.error("Error updating product:", error);
      alert("Failed to update product.");
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center z-50">
      <div className="bg-white border border-gray-200 rounded-lg shadow-2xl w-[400px] mx-5 sm:mx-auto transform transition-all duration-300 ease-in-out">
        {/* Header */}
        <div className="flex justify-between rounded-t-lg py-4 px-6 items-center border-b bg-gradient-to-r from-blue-600 to-blue-500">
          <h1 className="text-white text-xl font-semibold font-roboto">
            Add Deposit
          </h1>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full flex justify-center items-center hover:bg-blue-700 transition-colors duration-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <div className="flex flex-col space-y-4">
            {/* Deposit Input */}
            <div className="flex flex-col space-y-2">
              <label className="text-lg font-roboto text-gray-700 font-medium">
                Deposit:
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  value={advanceDepositValue}
                  onChange={(e) => setAdvanceDepositValue(e.target.value)}
                  className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  placeholder="Enter deposit"
                />

                <select
                  value={advanceDepositType}
                  onChange={(e) => setAdvanceDepositType(e.target.value)}
                  className="border border-gray-300 rounded-lg px-2 py-2 bg-white cursor-pointer focus:outline-none"
                >
                  <option value="%">%</option>
                  <option value="$">$</option>
                </select>
              </div>
            </div>

            {/* Add Deposit Button */}
            <button
              className="mt-4 px-4 py-2 bg-blue-600 font-roboto text-white rounded-lg hover:bg-blue-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              onClick={updateProduct}
            >
              Add Deposit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAddDeposit;
